<template>
    <div
    v-if="adShow"
    class="advertising-bg">
        <div class="advertising-box">
            <img
            class="advertising-qrcode"
            :src="require('@/assets/wx-public.jpg')">

            <div class="advertising-text">
                <span>扫码关注</span>
                <p>获取在线教育靠谱资讯</p>
            </div>

            <img
            class="advertising-phone"
            :src="require('@/assets/phone.png')">
            <i
            class="el-icon-close"
            @click="adClose()"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Advertising',
    data() {
        return {
            adShow: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.adShow = true
        }, 5000)
    },
    methods: {
        adClose() {
            this.adShow = false
        }
    }
}
</script>